import { TransactionType } from '@shared/helpers/enums/transaction-type';
import { Mapper } from '@shared/helpers/mapper';
import {
  CreateSecurityQuestionAnswerRequest,
  CreateSecurityRequest,
  CreateSecurityTaxRateRequest,
} from '../../../../web-api-client';
import { SecurityForm } from '../../abstractions/security-form';
import { EvaluationQuestion } from '../../models/evaluation-question';
import { EvaluationTaxResult } from '../../models/evaluation-tax-result';

export const mapSecurityToCreateSecurityRequest = (
  taxResults: EvaluationTaxResult[],
  questions: EvaluationQuestion[],
  formValue: Partial<SecurityForm>,
  selectedTransactionType: TransactionType | undefined
): CreateSecurityRequest => {
  const isGeneralRates =
    selectedTransactionType === TransactionType.GeneralRates;

  return Mapper.map(taxResults, CreateSecurityRequest, [
    {
      entityId: isGeneralRates ? 0 : formValue.entity?.entityId,
      clientId: isGeneralRates ? formValue.clientId : undefined,
      generalRateEntityTypeId: isGeneralRates
        ? formValue.generalRateEntityTypeId
        : undefined,
      isActive: true,
      acquisitionDate:
        !isGeneralRates && formValue.acquisitionDate
          ? formValue.acquisitionDate[0]
          : undefined,
      investmentJurisdictionId:
        formValue.investmentJurisdiction?.investmentJurisdictionId,
      name: formValue.name,
      isinCusip: isGeneralRates ? undefined : formValue.isinCusip,
      securityTypeId: formValue.securityType?.securityTypeId,
      questionAnswers: Mapper.mapByList(
        questions,
        CreateSecurityQuestionAnswerRequest,
        [
          'name',
          'answer',
          'questionId',
          'taxPolicyId',
          'taxRuleId',
          {
            isActive: true,
          },
          'unsureAnswer',
        ]
      ),
      transactionTypeId: selectedTransactionType,
      taxRates: Mapper.mapByList(
        taxResults ?? [],
        CreateSecurityTaxRateRequest,
        [
          'taxResultItemTypeId',
          'securityTaxResultItemId',
          'taxPolicyId',
          'taxRuleId',
          'taxResultItemId',
          'rate',
          'description',
          {
            isActive: true,
          },
        ]
      ),
    },
  ]);
};
